import React, { Component } from 'react';
import {Form, Input} from "antd";

const { TextArea } = Input;

let Rebill=()=>{
    return <div className="spaceBox ">
        <Form.Item
            label="Dispute Details"
            style={{fontWeight:'bold'}}
        >
        </Form.Item>
        <Form.Item
            label="Requested Changes"
            name={'requestedChanges'}
            rules={[{ required: true }]}
        >
            <TextArea maxLength={255} />
        </Form.Item>
        <Form.Item
            label="Reason Description"
            name={'reasonDescription'}
            rules={[{ required: false }]}
        >
            <TextArea maxLength={255} />
        </Form.Item>
        <Form.Item
            label="Requested VAT ID"
            name={'requestVatId'}
            rules={[{ required: true}]}
        >
            <Input maxLength={20} />
        </Form.Item>
        <Form.Item
            label="Text To Appear On Credit Note"
            name={'textOnCreditNote'}
            rules={[{ required: false }]}
        >
            <Input maxLength={255} />
        </Form.Item>
        <Form.Item
            label="Customer Internal Reference"
            name={'customerInternalRef'}
            rules={[{ required: false }]}
        >
            <Input maxLength={40} />
        </Form.Item>

    </div>
}
class DisputeDetails extends Component{
    render() {
        return <div>
            {this.props.type==4?
                <Rebill />
                :
                <div className="spaceBox ">
                    <Form.Item
                        label="Dispute Details"
                        style={{fontWeight:'bold'}}
                    >
                    </Form.Item>
                    <Form.Item
                        label="Comments"
                        name={'comments'}
                        rules={[{ required: this.props.type==5 || this.props.type==7 || this.props.type==13 ?false:true }]}
                    >
                        <TextArea maxLength={255} />
                    </Form.Item>
                    {this.props.type==2||  //1 4 7 9
                    this.props.type==3 ||
                    this.props.type==5 ||
                    this.props.type==6 ||
                    this.props.type==8 ||
                    this.props.type==10 ||
                    this.props.type==11 ||
                    this.props.type==13 && !this.props.PPMass_checked?
                        <Form.Item
                            label="Text To Appear On Credit Note"
                            name={'textOnCreditNote'}
                            rules={[{ required: false }]}
                        >
                            <Input maxLength={255} />
                        </Form.Item>:''
                    }
                    {this.props.PPMass_checked?'':
                        <Form.Item
                            label="Customer Internal Reference"
                            name={'customerInternalRef'}
                            rules={[{ required: false}]}
                        >
                            <Input maxLength={40} />
                        </Form.Item>
                    }

                </div>
            }
        </div>


    }
}

export default DisputeDetails;